import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { Request } from 'src/app/models/Request';

@Injectable({
    providedIn: 'root'
})
export class RequestAtachmentApi extends Api<Request> {
}
